import React from "react";
import "./PageAboutUs.css";

function PageAboutUs() {
    return (
        <div className="about-page">
            <iframe
                title="About Us"
                src="https://gitstool.in/liquor/shop_app/aboutus.html"
                className="about-frame"
            />
        </div>
    );
}

export default PageAboutUs;